import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ApiHelper } from '../../apiHelper/ApiHelper';
import BlogCard from '../../components/BlogCard';
import { BlogPostPreview } from '../../components/blogUtils';
import useWindowDimensions from '../../hooks/size';
import Seo from '../../components/Seo';
import './styles/Blog.scss';

export default function Blog() {
    const { width } = useWindowDimensions();
    const [posts, setPosts] = useState<BlogPostPreview[]>([]);
    const [page, setPage] = useState(0);

    const navigate = useNavigate();
    const api = new ApiHelper();

    // How many cards fit a full grid row pair, scaled to viewport.
    const pageSize = width < 760 ? 4 : width < 1280 ? 6 : 9;

    async function fetch() {
        try {
            const res = await api.blogApi.getPosts();
            setPosts(await res.json());
        } catch (x: any) {
            api.processErrors(x);
        }
    }

    useEffect(() => {
        fetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Latest post is featured at the top; the rest fill the paginated grid.
    const featured = posts.length ? posts[0] : null;
    const rest = posts.slice(1);
    const pageCount = Math.max(1, Math.ceil(rest.length / pageSize));

    useEffect(() => {
        if (page > pageCount - 1) setPage(pageCount - 1);
    }, [page, pageCount]);

    const openPost = (url: string) => navigate('/blog/' + url);
    const visible = rest.slice(pageSize * page, pageSize * (page + 1));

    return (
        <div className="blog">
            <Seo
                title="Blog – Vše o cestě na medicínu"
                description="Články, rady a tipy k přijímačkám na medicínu – fyzika, chemie, biologie a zkušenosti studentů, kterým se podařilo dostat na lékařskou fakultu."
            />
            <header className="head">
                <p className="eyebrow">MYMED BLOG</p>
                <h1>Vše o cestě na medicínu</h1>
                <p className="lead">
                    Jak se studuje na lékařských fakultách? Na co se připravit k přijímačkám
                    a jak zvládnout ústní pohovory? Najdeš tu články o studiu medicíny,
                    přijímačkách, efektivním učení i aktualitách ze zdravotnictví.
                </p>
            </header>

            {!posts.length && (
                <p className="empty">Zatím tu nejsou žádné články. Brzy přidáme první!</p>
            )}

            {featured && page === 0 && (
                <section className="featuredWrap">
                    <BlogCard post={featured} featured onClick={() => openPost(featured.url)} />
                </section>
            )}

            {!!rest.length && (
                <>
                    <div className="grid">
                        {visible.map((p) => (
                            <BlogCard key={p.url} post={p} onClick={() => openPost(p.url)} />
                        ))}
                    </div>

                    {pageCount > 1 && (
                        <div className="pager">
                            <button
                                className="navBtn"
                                disabled={page <= 0}
                                onClick={() => setPage((x) => Math.max(0, x - 1))}
                                aria-label="Předchozí"
                            >
                                <i className="chev left" />
                            </button>
                            <span className="count">{page + 1} / {pageCount}</span>
                            <button
                                className="navBtn"
                                disabled={page >= pageCount - 1}
                                onClick={() => setPage((x) => Math.min(pageCount - 1, x + 1))}
                                aria-label="Další"
                            >
                                <i className="chev right" />
                            </button>
                        </div>
                    )}
                </>
            )}
        </div>
    );
}
